<template>
  <div class="mg-r-10 mt-n1">
    <Dropdown @command="menuClicked" placement="top-start">
      <!-- <span class="el-dropdown-link">
            Dropdown List<i class="el-icon-arrow-down el-icon--right"></i>
        </span> -->
      <button class="btn btn-xs btn-outline-primary btn-uppercase mg-t-5">
        <feather type="menu" class="wd-20-f ht-20-f mg-r-5"></feather>цэс
      </button>
      <DropdownMenu slot="dropdown" class="wd-200">
        <DropdownItem command="edit" icon="el-icon-edit">Засах</DropdownItem>
        <!-- <DropdownItem icon="el-icon-arrow-right" divided><DropdownMenu slot="dropdown" class="wd-200"></DropdownMenu>
            
            </DropdownItem> -->

        <DropdownItem
          command="delete"
          icon="el-icon-delete"
          divided
          class="text-danger"
          >Устгах</DropdownItem
        >
      </DropdownMenu>
    </Dropdown>
  </div>
</template>

<script>
import "element-ui/lib/theme-chalk/index.css";
import { Dropdown, DropdownMenu, DropdownItem } from "element-ui";
export default {
  props: {},
  components: {
    Dropdown,
    DropdownMenu,
    DropdownItem
  },
  methods: {
    menuClicked(e) {
      this.$emit("on-menu-clicked", e);
      //console.log('dsfd', e);
    }
  }
};
</script>

<style></style>
